import React, { useContext } from "react";
import { useThread } from "../context/ThreadContext";
import { AuthContext } from "../context/AuthContext";
import NewChat from "./NewChat";
import NavLinksContainer from "./NavLinksContainer";
import FolderList from "./FolderList";
import { FolderService } from "../services/FolderService";

const NavContent = () => {
  const { state, dispatch } = useThread();
  const { currentUser } = useContext(AuthContext);
  const { threads = [], currentThread, folders = [] } = state;

  const handleThreadClick = (thread) => {
    dispatch({ type: 'SET_CURRENT_THREAD', payload: thread });
  };

  // Get threads that aren't in any folder
  const unorganizedThreads = threads.filter(thread => 
    !folders?.some(folder => folder.threads?.includes(thread.id))
  );

  const handleDrop = async (e) => {
    e.preventDefault();
    const threadId = e.dataTransfer.getData('threadId');
    if (threadId) {
      try {
        // Remove thread from all folders
        for (const folder of folders) {
          if (folder.threads?.includes(threadId)) {
            await FolderService.removeThreadFromFolder(folder.id, threadId);
          }
        }
        // Fetch updated folders
        const updatedFolders = await FolderService.getUserFolders(currentUser.uid);
        dispatch({ type: 'SET_FOLDERS', payload: updatedFolders });
      } catch (error) {
        console.error('Error removing thread from folder:', error);
      }
    }
  };

  return (
    <div className="nav-content">
      <NewChat />
      <div className="scrollable-content"
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <FolderList />
        <div className="threads-list">
          {unorganizedThreads.map((thread) => (
            <div
              key={thread.id}
              className={`thread-item ${currentThread?.id === thread.id ? 'active' : ''}`}
              onClick={() => handleThreadClick(thread)}
              draggable
              onDragStart={(e) => {
                e.dataTransfer.setData('threadId', thread.id);
              }}
            >
              <div className="thread-title">{thread.title}</div>
              <div className="thread-preview">
                {thread.messages[thread.messages.length - 1]?.content.substring(0, 30)}...
              </div>
            </div>
          ))}
        </div>
      </div>
      <NavLinksContainer />
    </div>
  );
};

export default NavContent;
